var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.804 4.448H3.87a1.766 1.766 0 0 0-1.764 1.764v8.23a1.765 1.765 0 0 0 1.764 1.764h.812l1.014 2.027a.587.587 0 0 0 .817.248l3.98-2.275h6.311a1.765 1.765 0 0 0 1.764-1.763V6.212a1.766 1.766 0 0 0-1.764-1.764zm-1.176 5.88H5.046a.588.588 0 0 1 0-1.177h10.582a.588.588 0 1 1 0 1.176zm0-2.353H5.046a.588.588 0 1 1 0-1.176h10.582a.588.588 0 1 1 0 1.176z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBlack);
export default __webpack_public_path__ + "static/media/messageBlack.c76b3e64ac6942b0606981f7f6acd738.svg";
export { ForwardRef as ReactComponent };